module.exports = __webpack_public_path__ + "img/cc-range.7a179180.png";